import React from 'react';
import RequestSteps from '../containers/RequestSteps';
import { nextRequestStepIndex, previousRequestStepIndex } from '../helper';
import { requestSteps } from '../constants';
import RequestAccessWizardContent from './RequestAccessWizardContent';
import SelectSourceActions from '../containers/SelectSourceActions';
import DestinationInfoActions from '../containers/DestinationInfoActions';
import RequestWorkspaceActions, {
  validateRequestWorkspaceStep,
} from '../workspaces/components/RequestWorkspaceActions';
import SelectAttachmentsActions from '../attachments/components/SelectAttachmentsActions';
import ProjectInfoActions, { validateRequestProjectStep } from '../containers/ProjectInfoActions';
import AboutInfoActions from '../containers/AboutInfoActions';
import CompleteActions from './CompleteActions';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const wizardActions = {
  [requestSteps.SOURCE.name]: { component: SelectSourceActions },
  [requestSteps.DESTINATION.name]: { component: DestinationInfoActions },
  [requestSteps.WORKSPACE.name]: { component: RequestWorkspaceActions, validator: validateRequestWorkspaceStep },
  [requestSteps.ATTACHMENTS.name]: { component: SelectAttachmentsActions },
  [requestSteps.PROJECT.name]: { component: ProjectInfoActions, validator: validateRequestProjectStep },
  [requestSteps.ABOUT.name]: { component: AboutInfoActions },
  [requestSteps.COMPLETE.name]: { component: CompleteActions },
};

const RequestAccessWizard = ({ category, code, compact }) => {
  const state = Selectors.useRequestAccessWizard({ category, code });
  const updateStep = Events.useUpdateActiveStep(category, { code });
  const updateProperties = Events.useUpdateRequestProperties(category, { code });
  const activeStep = Object.values(requestSteps)[state.activeStepIndex].name;

  const validateStep = () => {
    const validator = wizardActions[activeStep]?.validator;
    return validator ? validator(state) : [];
  };

  const goToStep = (step) => {
    if (step < Object.values(requestSteps).length && step >= 0) {
      updateStep({ step });
    }
  };

  const goForward = () => {
    const validationErrors = validateStep();
    updateProperties({ properties: { saveErrors: validationErrors } });

    if (validationErrors.length === 0) {
      goToStep(nextRequestStepIndex(state));
    }
  };

  const RequestAccessActions = wizardActions[activeStep]?.component;

  return (
    <div className={compact ? 'tab-wizard-compact' : 'tab-wizard'}>
      <RequestSteps category={category} code={code} compact={compact} goToStep={goToStep} />
      <RequestAccessWizardContent activeStep={activeStep} category={category} code={code} compact={compact} />
      <RequestAccessActions
        category={category}
        code={code}
        compact={compact}
        goBack={() => goToStep(previousRequestStepIndex(state))}
        goForward={goForward}
      />
    </div>
  );
};

export default RequestAccessWizard;
